
export default {
    setStatusVaga(state, data) {
        state.statusVaga = data
    },
    setStatusVagas(state, data) {
        state.statusVagas = data
    },
}